export default {
	"transSec.SorryFailedToCreateOrder": "抱歉，創建訂單失敗！",
	"transSec.CopiedSuccessfully": "已成功複製！",
	"transSec.ReplicationIsNotSupported": "不支援複製",
	"transSec.ParameterError": "參數錯誤！",
	"transSec.CongratulationsOnYourSuccessfulUpgrade": "恭喜您已升級成功",
	"transSec.CallItOfficial": "叫叫官方",
	"transSec.UpgradeContent": "升級內容：",
	"transSec.UpgradeType": "升級類型：",
	"transSec.SubscriptionsArePaidAnnually": "訂閱轉年付",
	"transSec.TheAmountOfTheItem": "商品金額",
	"transSec.SubscriptionPaidIn": "訂閱實付",
	"transSec.UpgradeOffers": "升級優惠",
	"transSec.expenses": "費用",
	"transSec.AfterTheUpgradeIsSuccessfulYouCanViewYourUpgradeInformationInTheFirstOrderOfTheSubscriptionAtTheSameTimeTheAutomaticDeductionOfTheOriginalSubscriptionWillBeAutomaticallyTerminatedThroughTheSystemAndWillNotBeRepeatedlyCharged": "升級成功后，您可在訂閱的首個訂單中查看您的升級資訊; 同時原訂閱自動扣款將通過系統自動解約，不會重複扣款",
	"transSec.OrderNumber": "訂單編號",
	"transSec.copy": "複製",
	"transSec.TheTimeOfPlacingTheOrder": "下單時間",
	"transSec.PaymentMethods": "支付方式",
	"transSec.PaymentTime": "支付時間",
	"transSec.ActualPayment": "實付款：",
	"transSec.DetermineTheUpgrade": "確定升級",
	"transSec.prompt": "提示",
	"transSec.GotIt": "知道了",
	"transSec.ToPayForThisOrderPleasePayInTheOrderLogisticsOfTheCallPublicAccount": "支付該訂單請在《叫叫》公眾號的訂單物流中進行支付",
	"transSec.TheUpgradeRateChangesDueToChangesInTheNumberOfSubscriptionPeriods": "因您的訂閱期數發生變化導致升級幅度變動",
	"transSec.ItemAmount": "商品金額：",
	"transSec.SubscriptionPayment": "訂閱實付：",
	"transSec.UpgradeOffer": "升級優惠：",
	"transSec.Expenses": "費用：",
	"transSec.return": "返回",
	"transSec.GoOn": "繼續"
}